"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FSArbitragingProcessor = exports.FSAInvestRemainReason = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_quotation_lib_1 = require("trade_quotation_lib");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const ErrorUtils_1 = require("../../CommonUtils/ErrorUtils");
const BinanceFutureMarginCalculator_1 = require("../../CommonUtils/FutureUtils/BinanceFutureMarginCalculator");
const FutureUtils_1 = require("../../CommonUtils/FutureUtils/FutureUtils");
const TextAndSliderSyncTool_1 = require("../../CommonUtils/TextAndSliderSyncTool");
const FutureManualProcessor_1 = require("../../FutureManualTrading/FutureManualProcessor");
const FSATools_1 = require("../FSATools");
var FSAInvestRemainReason;
(function (FSAInvestRemainReason) {
    FSAInvestRemainReason["total_investment"] = "total_investment";
    FSAInvestRemainReason["total_investment_with_extra_quota"] = "total_investment_with_extra_quota";
    FSAInvestRemainReason["total_investment_alt_coin"] = "total_investment_alt_coin";
    FSAInvestRemainReason["total_investment_alt_coin_with_extra_quota"] = "total_investment_alt_coin_with_extra_quota";
    FSAInvestRemainReason["single_coin_investment_alt_coin"] = "single_coin_investment_alt_coin";
    FSAInvestRemainReason["single_coin_investment_alt_coin_with_extra_quota"] = "single_coin_investment_alt_coin_with_extra_quota";
    FSAInvestRemainReason["total_investment_whole_net"] = "total_investment_whole_net";
})(FSAInvestRemainReason || (exports.FSAInvestRemainReason = FSAInvestRemainReason = {}));
exports.FSArbitragingProcessor = {
    useUserParams: (base, quote, invest, investPercent, investActionType, priceDiffPercent, orderType, symbolMap, balance, leverage, spotPrice, futurePrice, tradeAPI, futureAPI) => {
        const [spotSymbol, setSpotSymbol] = (0, react_1.useState)(); // 实际现货symbol
        const [swapSymbol, setSwapSymbol] = (0, react_1.useState)(); // 实际期货symbol
        (0, react_1.useEffect)(() => {
            if (!base || !quote) {
                return;
            }
            const spotS = symbolMap.get(`${base}/${quote}`);
            const swapS = symbolMap.get(`${base}.SWAP/${quote}`);
            if (spotS && swapS && spotS.baseDisplay === swapS.baseDisplay) {
                setSpotSymbol(spotS);
                setSwapSymbol(swapS);
            }
            else {
                setSpotSymbol(undefined);
                setSwapSymbol(undefined);
            }
        }, [base, quote, symbolMap]);
        const [isValidSymbol, precision] = (0, react_1.useMemo)(() => {
            const isValid = !!spotSymbol && !!swapSymbol;
            let precision = 2;
            if (spotSymbol && swapSymbol) {
                precision = trade_utils_lib_1.SafeDecimal.min(spotSymbol.precision || 0, swapSymbol.precision || 0).toNumber();
            }
            return [isValid, precision];
        }, [spotSymbol, swapSymbol]);
        const [remainData, remainLoading] = exports.FSArbitragingProcessor.useRemainInvest(isValidSymbol ? spotSymbol === null || spotSymbol === void 0 ? void 0 : spotSymbol.base : undefined, isValidSymbol ? spotSymbol === null || spotSymbol === void 0 ? void 0 : spotSymbol.quote : undefined);
        const priceDiffLimit = (0, react_1.useMemo)(() => {
            return new trade_utils_lib_1.SafeDecimal(priceDiffPercent).mul(0.01).toString();
        }, [priceDiffPercent]);
        const priceOffsetRate = exports.FSArbitragingProcessor.useFSAPriceGap(TradeAPILib_1.ExchangeID.PIONEXV2, isValidSymbol ? spotSymbol === null || spotSymbol === void 0 ? void 0 : spotSymbol.base : undefined, isValidSymbol ? spotSymbol === null || spotSymbol === void 0 ? void 0 : spotSymbol.quote : undefined, TradeAPILib_1.ExchangeID.PIONEX_SWAP, swapSymbol === null || swapSymbol === void 0 ? void 0 : swapSymbol.base, swapSymbol === null || swapSymbol === void 0 ? void 0 : swapSymbol.quote);
        const fundingFeeRateHistories = (0, FSATools_1.useArbitrageFundingFeeRateHistories)(orderType, isValidSymbol ? spotSymbol === null || spotSymbol === void 0 ? void 0 : spotSymbol.symbol : "", leverage, true);
        const fundingFeeRateHistory = fundingFeeRateHistories.length && spotSymbol ? fundingFeeRateHistories[0] : undefined;
        const fundingCountDown = (0, FutureUtils_1.useFundingRateCountDown)(isValidSymbol ? fundingFeeRateHistory === null || fundingFeeRateHistory === void 0 ? void 0 : fundingFeeRateHistory.next_funding_fee_time : undefined);
        const fundingRateStr = (0, react_1.useMemo)(() => {
            const rate = fundingFeeRateHistory === null || fundingFeeRateHistory === void 0 ? void 0 : fundingFeeRateHistory.last_funding_fee_rate;
            const rateStr = rate ? trade_utils_lib_1.NumberCommonUtils.toPercent(new trade_utils_lib_1.SafeDecimal(rate).mul(100), false, true, 4) : "--";
            return `${rateStr} / ${fundingCountDown}`;
        }, [fundingCountDown, fundingFeeRateHistory === null || fundingFeeRateHistory === void 0 ? void 0 : fundingFeeRateHistory.last_funding_fee_rate]);
        const minInvest = (0, react_1.useMemo)(() => {
            var _a;
            const standardMin = exports.FSArbitragingProcessor.queryStandardMinInvest(isValidSymbol ? (_a = spotSymbol === null || spotSymbol === void 0 ? void 0 : spotSymbol.base) !== null && _a !== void 0 ? _a : "" : "");
            return exports.FSArbitragingProcessor.queryMinInvest(spotSymbol, swapSymbol, spotPrice, futurePrice, new trade_utils_lib_1.SafeDecimal(leverage).toNumber(), standardMin);
        }, [isValidSymbol, spotSymbol, swapSymbol, spotPrice, futurePrice, leverage]);
        const maxInvest = (0, react_1.useMemo)(() => {
            const availableBalance = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(balance, precision);
            if (remainData === null || remainData === void 0 ? void 0 : remainData.remain) {
                return trade_utils_lib_1.SafeDecimal.min(availableBalance, new trade_utils_lib_1.SafeDecimal(remainData === null || remainData === void 0 ? void 0 : remainData.remain)).toString();
            }
            return availableBalance.toString();
        }, [balance, precision, remainData === null || remainData === void 0 ? void 0 : remainData.remain]);
        const [parseInvest, parseInvestPercent] = TextAndSliderSyncTool_1.TextAndSliderSyncTool.useGridInvestAndInvestPercent(investActionType, invest, investPercent, balance, precision);
        const leverageConfig = FutureManualProcessor_1.FutureManualProcessor.useLeverageConfigure((swapSymbol === null || swapSymbol === void 0 ? void 0 : swapSymbol.base) || "", (swapSymbol === null || swapSymbol === void 0 ? void 0 : swapSymbol.quote) || "", futureAPI);
        const liquidationPrice = (0, react_1.useMemo)(() => {
            const leverageD = new trade_utils_lib_1.SafeDecimal(leverage);
            const position = new trade_utils_lib_1.SafeDecimal(parseInvest || 1000).mul(leverageD.div(leverageD.add(1))).div(new trade_utils_lib_1.SafeDecimal(futurePrice));
            const liquidation = BinanceFutureMarginCalculator_1.BinanceFutureMarginCalculator.getLiquidationPriceMatchMaintenances(new trade_utils_lib_1.SafeDecimal(futurePrice), position, new trade_utils_lib_1.SafeDecimal(0.0004), new trade_utils_lib_1.SafeDecimal(1).div(new trade_utils_lib_1.SafeDecimal(leverage)), new trade_utils_lib_1.SafeDecimal(0), (leverageConfig === null || leverageConfig === void 0 ? void 0 : leverageConfig.maintenance_margin_levels) || [], "short");
            const filter5percent = new trade_utils_lib_1.SafeDecimal(liquidation).mul(0.95);
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(filter5percent, swapSymbol === null || swapSymbol === void 0 ? void 0 : swapSymbol.precision);
        }, [futurePrice, leverage, leverageConfig === null || leverageConfig === void 0 ? void 0 : leverageConfig.maintenance_margin_levels, parseInvest, swapSymbol === null || swapSymbol === void 0 ? void 0 : swapSymbol.precision]);
        const investState = (0, react_1.useMemo)(() => {
            const state = {
                state: "normal",
                min: minInvest,
                max: maxInvest,
            };
            if (parseInvest) {
                if (new trade_utils_lib_1.SafeDecimal(parseInvest).lessThan(new trade_utils_lib_1.SafeDecimal(minInvest))) {
                    state.state = "small";
                }
                if (new trade_utils_lib_1.SafeDecimal(parseInvest).greaterThan(new trade_utils_lib_1.SafeDecimal(maxInvest))) {
                    state.state = "large";
                }
            }
            return state;
        }, [minInvest, maxInvest, parseInvest]);
        const emptyErrors = (0, react_1.useMemo)(() => {
            const emptys = [];
            if (!Number(parseInvest)) {
                emptys.push("trading_total_investment");
            }
            return emptys;
        }, [parseInvest]);
        return {
            invest: parseInvest,
            investPercent: parseInvestPercent,
            investState,
            balance,
            spotSymbol,
            swapSymbol,
            precision,
            isValidSymbol,
            fundingRate: fundingRateStr,
            orderType,
            minInvest,
            maxInvest,
            emptyErrors,
            priceOffsetRate,
            leverage,
            liquidationPrice,
            fundingFeeRateHistory,
            tradeAPI,
            futureAPI,
            priceDiffLimit,
            remain: remainData,
            remainLoading: remainLoading,
        };
    },
    getCreateOrderRequest: (params, $st) => {
        if (params.emptyErrors.length > 0 || !params.swapSymbol || !params.spotSymbol) {
            throw $st("trade_params_not_fill_enough");
        }
        if (!params.isValidSymbol) {
            throw $st("trade_choose_symbol_support_fsa");
        }
        if (params.investState.state === "small") {
            throw $st("trade_error_low_amount", {
                amount: `${params.minInvest} ${params.swapSymbol.quote}`,
            });
        }
        else if (params.investState.state === "large") {
            if (new trade_utils_lib_1.SafeDecimal(params.invest).greaterThan(new trade_utils_lib_1.SafeDecimal(params.balance))) {
                throw $st("trade_error_balance_not_enough");
            }
            throw $st("trade_error_high_cost", {
                cost: `${params.investState.max} ${params.swapSymbol.quote}`,
            });
        }
        if (new trade_utils_lib_1.SafeDecimal(params.priceDiffLimit).lessThan(-0.5)) {
            throw $st("fsa_create_order_price_diff_too_low", { min: "-50%" });
        }
        return {
            type: params.orderType,
            spotBase: params.spotSymbol.base,
            spotQuote: params.spotSymbol.quote,
            spotExchange: TradeAPILib_1.ExchangeID.PIONEXV2,
            swapBase: params.swapSymbol.base,
            swapQuote: params.swapSymbol.quote,
            swapExchange: TradeAPILib_1.ExchangeID.PIONEX_SWAP,
            investment: params.invest,
            leverage: params.leverage,
            direction: "long",
            price_diff_limit: params.priceDiffLimit || "-0.001",
            price_ratio: "1",
        };
    },
    checkSymbolStatusValid(tradeAPI, spotSymbol, $st) {
        return (0, trade_utils_lib_1.requestWithRetry)(() => {
            return tradeAPI.querySymbolStatus({
                base: spotSymbol.base,
                quote: spotSymbol.quote,
            });
        }, { maxRetryCount: 2, name: "querySymbolStatus" }).pipe((0, operators_1.map)((result) => {
            if (result.status === TradeAPILib_1.SymbolStatus.MaintainedWithoutForbidden) {
                return {
                    result: false,
                    message: $st("symbol_under_maintenance_cannot_trade"),
                };
            }
            return { result: true, message: "" };
        }), (0, operators_1.catchError)((error) => {
            const errString = ErrorUtils_1.ErrorUtils.transErrorToString(error);
            throw {
                result: false,
                message: $st("check_symbol_status_error", { error: errString }),
            };
        }));
    },
    checkCoinsTransferInfo(tradeAPI, spotSymbol, $st) {
        return (0, trade_utils_lib_1.requestWithRetry)(() => {
            return tradeAPI.queryCoinTransferInfo();
        }, { maxRetryCount: 2, name: "queryCoinTransferInfo" }).pipe((0, operators_1.map)((result) => {
            const spotSymbolReject = result.spotCoins.find((item) => item.base === spotSymbol.base && item.quote === spotSymbol.quote) !== undefined;
            const futureCoinReject = result.futureCoins.find((item) => item.coin === spotSymbol.quote && item.futureUsdtStatus === TradeAPILib_1.CoinTransferStatus.disabled) !== undefined;
            if (spotSymbolReject) {
                return {
                    result: false,
                    message: $st("symbol_under_maintenance_cannot_trade"),
                };
            }
            if (futureCoinReject) {
                return {
                    result: false,
                    message: $st("fsa_transfer_status_disabled_error"),
                };
            }
            return { result: true, message: "" };
        }), (0, operators_1.catchError)((error) => {
            const errString = ErrorUtils_1.ErrorUtils.transErrorToString(error);
            throw {
                result: false,
                message: $st("check_symbol_status_error", { error: errString }),
            };
        }));
    },
    verifyOrder(params, $st) {
        if (!params.isValidSymbol || !params.swapSymbol || !params.spotSymbol) {
            return (0, rxjs_1.of)({
                result: false,
                message: $st("trade_choose_symbol_support_fsa"),
            });
        }
        return this.checkCoinsTransferInfo(params.tradeAPI, params.spotSymbol, $st).pipe((0, operators_1.map)((result) => {
            if (result.result === false) {
                return result;
            }
            return { result: true, message: "" };
        }), (0, operators_1.catchError)((error) => {
            return (0, rxjs_1.of)(error);
        }));
    },
    /**
     * 计算期现差价百分比（期货价格-现货价格）/买入价格
     * 开仓时，差价越大（期货价格越高）越好（期货卖出，现货买入）
     * 平仓时，差价越小（期货价格越低）越好（期货买入，现货卖出）
     * @param spotExchange
     * @param spotBase
     * @param spotQuote
     * @param swapExchange
     * @param swapBase
     * @param swapQuote
     * @param openPosition
     * @param focused
     */
    useFSAPriceGap(spotExchange, spotBase, spotQuote, swapExchange, swapBase, swapQuote, openPosition = true, focused = true) {
        const spotOrderBookData = (0, trade_quotation_lib_1.useOrderBookData)({
            base: spotBase,
            quote: spotQuote,
            exchange: spotExchange,
            limit: 1,
            duration: 1000,
            focused,
        });
        const swapOrderBookData = (0, trade_quotation_lib_1.useOrderBookData)({
            base: swapBase,
            quote: swapQuote,
            exchange: swapExchange,
            limit: 1,
            duration: 1000,
            focused,
        });
        const [priceGap, setPriceGap] = (0, react_1.useState)();
        (0, react_1.useEffect)(() => {
            if (!spotOrderBookData ||
                spotOrderBookData.bids.length <= 0 ||
                spotOrderBookData.asks.length <= 0 ||
                !swapOrderBookData ||
                swapOrderBookData.bids.length <= 0 ||
                swapOrderBookData.asks.length <= 0) {
                setPriceGap(undefined);
                return;
            }
            if (openPosition) {
                //建仓/加仓
                // 现货买入, 用卖一价
                const spotBuyPrice = spotOrderBookData.asks[0].price;
                // 合约卖出, 用买一价
                const swapSellPrice = swapOrderBookData.bids[0].price;
                // 期现差价 = 期货价格 - 现货价格
                setPriceGap((swapSellPrice - spotBuyPrice) / spotBuyPrice);
            }
            else {
                // 减仓/平仓
                // 现货卖出, 用买一价
                const spotSellPrice = spotOrderBookData.bids[0].price;
                // 合约买入(平仓), 用卖一价
                const swapBuyPrice = swapOrderBookData.asks[0].price;
                // 期现差价 = 期货价格 - 现货价格
                setPriceGap((swapBuyPrice - spotSellPrice) / swapBuyPrice);
            }
        }, [
            spotExchange,
            spotQuote,
            spotBase,
            swapExchange,
            swapBase,
            swapQuote,
            focused,
            openPosition,
            spotOrderBookData,
            swapOrderBookData,
        ]);
        return (0, react_1.useMemo)(() => {
            if (priceGap === undefined || isNaN(priceGap)) {
                return "--%";
            }
            return trade_utils_lib_1.NumberCommonUtils.toPercent(priceGap * 100, false, true, 3);
        }, [priceGap]);
    },
    /**
     * 开仓时起投额满足： 非主流币：1000U 主流币: ETH: 100U BTC: 300U
     */
    queryStandardMinInvest(coin) {
        let standardMin = 1000;
        if (coin === "BTC") {
            standardMin = 300;
        }
        else if (coin === "ETH") {
            standardMin = 100;
        }
        return standardMin;
    },
    /**
     * 现货最小投资额：max{min（amount）*price *1.2，min(dumping),min（cost））}
     * 合约最小投资额：max{min（spending）*price * 1.2，min（dumping）* price * 1.2 }
     * Max（现货最小投资额，合约最小投资额）* 2
     *
     * @param spotSymbol
     * @param swapSymbol
     * @param spotPrice
     * @param futurePrice
     * @param leverage // 杠杆倍数
     */
    queryMinInvest(spotSymbol, swapSymbol, spotPrice, futurePrice, leverage, standardMin) {
        var _a, _b, _c, _d, _e;
        if (!spotSymbol || !swapSymbol || !spotPrice || !futurePrice || !leverage) {
            return "";
        }
        const spotLimitMin = new trade_utils_lib_1.SafeDecimal((_a = spotSymbol.limit) === null || _a === void 0 ? void 0 : _a.amount.min).mul(new trade_utils_lib_1.SafeDecimal(spotPrice)).mul(1.2);
        const spotMarketMin = new trade_utils_lib_1.SafeDecimal((_b = spotSymbol.limit) === null || _b === void 0 ? void 0 : _b.dumping.min).mul(new trade_utils_lib_1.SafeDecimal(spotPrice)).mul(1.2);
        // min * (1 + 1/leverage) // 1 为现货投资额. 1/leverage为合约投资额
        const spotMin = trade_utils_lib_1.SafeDecimal.max(spotLimitMin, spotMarketMin, new trade_utils_lib_1.SafeDecimal((_c = spotSymbol.limit) === null || _c === void 0 ? void 0 : _c.cost.min)).mul(1 + 1 / leverage);
        const futurePriceDecimal = new trade_utils_lib_1.SafeDecimal(futurePrice);
        const swapSpending = new trade_utils_lib_1.SafeDecimal((_d = swapSymbol.limit) === null || _d === void 0 ? void 0 : _d.spending.min).mul(futurePriceDecimal).mul(1.2);
        const swapDumping = new trade_utils_lib_1.SafeDecimal((_e = swapSymbol.limit) === null || _e === void 0 ? void 0 : _e.dumping.min).mul(futurePriceDecimal).mul(1.2);
        // 新增币安合约最小交易5刀限制(reduce only 不限制)
        // 合约5刀交易量所需要的保证金
        // 5刀可以买多少量, 向上取整是因为要计算可交易的最小量, 所以取最大值. 先转换成量是为了避免精度问题
        const fiveCanBuy = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(new trade_utils_lib_1.SafeDecimal(FutureManualProcessor_1.BINANCE_SWAP_MIN_INVEST).div(new trade_utils_lib_1.SafeDecimal(futurePrice)), swapSymbol.amount, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
        const fiveUNeeded = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(fiveCanBuy.mul(futurePriceDecimal).mul(1.2), swapSymbol.precision);
        // 合约最少需要的保证金: min * ( 1 / leverage);
        // 由合约计算出来的期现套利最小投资额: 合约最少需要的保证金 * ( 1 + leverage );
        const swapMin = trade_utils_lib_1.SafeDecimal.max(swapDumping, swapSpending, fiveUNeeded)
            .mul(1 / leverage)
            .mul(1 + leverage);
        let min = trade_utils_lib_1.SafeDecimal.max(spotMin, swapMin);
        if (standardMin) {
            min = trade_utils_lib_1.SafeDecimal.max(new trade_utils_lib_1.SafeDecimal(standardMin), min);
        }
        const precision = trade_utils_lib_1.SafeDecimal.min(new trade_utils_lib_1.SafeDecimal(spotSymbol.precision), new trade_utils_lib_1.SafeDecimal(swapSymbol.precision)).toNumber();
        return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(min, precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
    },
    /**
     * 现货最小数量：Max(amount ,min (cost) / price * 1.2)
     * 期货最小数量：Min(dumping)
     * Max(现货最小数量，期货最小数量)*2
     * @param spotSymbol
     * @param swapSymbol
     * @param spotPrice
     */
    queryMinAmount(spotSymbol, swapSymbol, spotPrice) {
        var _a, _b, _c, _d;
        if (!spotSymbol || !swapSymbol) {
            return "";
        }
        let spotMinAmount = new trade_utils_lib_1.SafeDecimal((_a = spotSymbol.limit) === null || _a === void 0 ? void 0 : _a.amount.min);
        const spotPriceDecimal = new trade_utils_lib_1.SafeDecimal(spotPrice);
        if (spotPriceDecimal.toNumber()) {
            // 现货最小成交额转换最小amount
            const spotCostTransMin = new trade_utils_lib_1.SafeDecimal((_b = spotSymbol.limit) === null || _b === void 0 ? void 0 : _b.cost.min).div(spotPriceDecimal).mul(1.2);
            spotMinAmount = trade_utils_lib_1.SafeDecimal.max(spotCostTransMin, new trade_utils_lib_1.SafeDecimal((_c = spotSymbol.limit) === null || _c === void 0 ? void 0 : _c.amount.min));
        }
        const swapMinAmount = new trade_utils_lib_1.SafeDecimal((_d = swapSymbol.limit) === null || _d === void 0 ? void 0 : _d.dumping.min);
        const min = trade_utils_lib_1.SafeDecimal.max(spotMinAmount, swapMinAmount).mul(2);
        const amountPrecision = trade_utils_lib_1.SafeDecimal.min(new trade_utils_lib_1.SafeDecimal(spotSymbol.amount), new trade_utils_lib_1.SafeDecimal(swapSymbol.amount)).toNumber();
        return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(min, amountPrecision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
    },
    /**
     *  查询fsa 最多可提取利润
     * @param order
     * @param markPrice
     */
    queryMaxProfitWithDrawn(order, markPrice) {
        if (order.orderType !== TradeAPILib_1.ExchangeOrderType.fsa) {
            return "0";
        }
        if (!order.exchangeFSAOrder) {
            return "0";
        }
        if (markPrice === 0) {
            return "0";
        }
        const temp = new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.swapInitMargin)
            .add(new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.swapPosition).mul(new trade_utils_lib_1.SafeDecimal(markPrice).sub(new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.swapOpenPrice))))
            .sub(new trade_utils_lib_1.SafeDecimal(markPrice)
            .mul(new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.swapPosition).abs())
            .mul(new trade_utils_lib_1.SafeDecimal(1).div(new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.leverage))));
        const temp2 = new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.totalFundingFee).sub(new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.profitWithdrawn));
        if (temp.lessThan(new trade_utils_lib_1.SafeDecimal(0)) || temp2.lessThan(new trade_utils_lib_1.SafeDecimal(0))) {
            return "0";
        }
        return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(trade_utils_lib_1.SafeDecimal.min(temp, temp2), 0);
    },
    /**
     * 查询fsa 最多可提取保证金
     * @param order
     * @param markPrice
     */
    queryFSAMaxMarginWithDrawn(order, markPrice) {
        if (order.orderType !== TradeAPILib_1.ExchangeOrderType.fsa) {
            return "0";
        }
        if (!order.exchangeFSAOrder) {
            return "0";
        }
        if (markPrice === 0) {
            return "0";
        }
        const temp = new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.swapInitMargin)
            .add(new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.swapPosition).mul(new trade_utils_lib_1.SafeDecimal(markPrice).sub(new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.swapOpenPrice))))
            .sub(new trade_utils_lib_1.SafeDecimal(markPrice)
            .mul(new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.swapPosition).abs())
            .mul(new trade_utils_lib_1.SafeDecimal(1).div(new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.leverage))));
        if (temp.lessThan(new trade_utils_lib_1.SafeDecimal(0))) {
            return "0";
        }
        return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(temp, 0);
    },
    /**
     * 追加、提起保证金后，计算爆仓价
     * @param position
     * @param currentMargin
     * @param leverageConfig
     *
     * (逐仓账户总保证金 - 方向*持仓数量*开仓价格)/(持仓数量*维持保证金费率 - 持仓数量*方向)
     */
    calcLiquidatePriceAfterMargin(order, currentMargin, leverageConfig, markPrice) {
        if (order.exchangeFSAOrder === undefined) {
            return "";
        }
        let positionSide = 1;
        if (new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.swapPosition).lessThan(new trade_utils_lib_1.SafeDecimal(0))) {
            positionSide = -1;
        }
        let ratio = 0;
        const leverage_level = leverageConfig.find((value) => {
            // @ts-ignore
            const findKey = `${order.exchangeFSAOrder.swapBase}_${order.exchangeFSAOrder.swapQuote}`;
            const index = value.symbols.indexOf(findKey);
            return index >= 0;
        });
        if (leverage_level) {
            const nominalPositionValue = new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.swapPosition).mul(new trade_utils_lib_1.SafeDecimal(markPrice)).abs();
            const marginLevelInfo = leverage_level.maintenance_margin_levels
                .sort((a, b) => b.value - a.value)
                .find((margin_levels) => margin_levels.value <= Number(nominalPositionValue));
            if (marginLevelInfo === undefined) {
                return order.exchangeFSAOrder.liquidatedPrice.toString();
            }
            else {
                ratio = marginLevelInfo.ratio;
            }
        }
        else {
            return order.exchangeFSAOrder.liquidatedPrice.toString();
        }
        const temp = new trade_utils_lib_1.SafeDecimal(currentMargin)
            .sub(new trade_utils_lib_1.SafeDecimal(positionSide)
            .mul(new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.swapPosition).abs())
            .mul(new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.swapOpenPrice)))
            .div(new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.swapPosition)
            .abs()
            .mul(new trade_utils_lib_1.SafeDecimal(ratio))
            .sub(new trade_utils_lib_1.SafeDecimal(order.exchangeFSAOrder.swapPosition).abs().mul(new trade_utils_lib_1.SafeDecimal(positionSide))));
        if (temp.lessThanOrEqualTo(0)) {
            return "";
        }
        else {
            return temp.toString();
        }
    },
    /**
     * 查询 binance 关于合约配置信息
     * @param tradeApi
     * @param queryOpen  //合约部分订单只在运行中订单查询，故此值，其余默认传true
     * @param isFocused
     */
    useBinanceLeverageConfig(tradeApi, isFocused, queryOpen = true) {
        const [symbolConfigure, setSymbolConfigure] = (0, react_1.useState)(undefined);
        const [loading, setLoading] = (0, react_1.useState)(true);
        (0, react_1.useEffect)(() => {
            if (!queryOpen) {
                setSymbolConfigure([]);
                return;
            }
            if (!isFocused) {
                return;
            }
            if (tradeApi === undefined) {
                return;
            }
            const tempObserve = (0, trade_utils_lib_1.requestWithRetry)(() => tradeApi.requestBinanceLeverageConfigures("binance")).subscribe({
                next: (data) => {
                    if (data) {
                        setSymbolConfigure(data.leverage_levels);
                    }
                    else {
                        console.log(`BinanceFutureMarginCalculator leverage_configs.json not get`);
                    }
                    setLoading(false);
                },
                error: (error) => {
                    console.log(error);
                    setLoading(false);
                }
            });
            return () => {
                tempObserve && tempObserve.unsubscribe();
            };
        }, [queryOpen, tradeApi, isFocused]);
        return [symbolConfigure, loading];
    },
    /**
     *
     * @param orderInfo
     *
     *
     * 设定x 为下次自动减仓价格
     * n = 自动减仓所需增加的杠杆倍数
     * abs(position) * x = (margin + (avgOpenPrice-x)*abs(position)) * (leverage+n)
     * x = (margin *(leverage+2) / abs(position) +avgOpenPrice *(leverage+n)) /(1+(leverage+n))
     */
    useNextReducePositionPrice(orderInfo) {
        const [nextPrice, setNextPrice] = (0, react_1.useState)("0");
        (0, react_1.useEffect)(() => {
            if (orderInfo === undefined) {
                setNextPrice("0");
                return;
            }
            if (orderInfo.exchangeFSAOrder === undefined) {
                setNextPrice("0");
                return;
            }
            const n = 1;
            let swapPosition = Math.abs(orderInfo.exchangeFSAOrder.swapPosition);
            let currentMargin = orderInfo.exchangeFSAOrder.swapInitMargin;
            let avgOpenPrice = orderInfo.exchangeFSAOrder.swapOpenPrice;
            let initLeverage = orderInfo.exchangeFSAOrder.leverage;
            if (new trade_utils_lib_1.SafeDecimal(swapPosition).equals(new trade_utils_lib_1.SafeDecimal(0))) {
                setNextPrice("0");
                return;
            }
            let tempNextPrice = new trade_utils_lib_1.SafeDecimal(currentMargin)
                .mul(initLeverage + n)
                .div(swapPosition)
                .add(new trade_utils_lib_1.SafeDecimal(avgOpenPrice).mul(initLeverage + n))
                .div(1 + (initLeverage + n));
            setNextPrice(tempNextPrice.toString());
        }, [orderInfo]);
        return nextPrice;
    },
    queryRemainInvestQuota(base, quote) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/fsa/quota/`;
        return trade_utils_lib_1.ObservableUtils.getV2(url, { base: base, quote: quote }, undefined, true);
    },
    /**
     * 返回值 [a,b,c]
     * a: 剩余额度
     * b: 是否正在请求中
     * c: 错误信息
     */
    useRemainInvest(base, quote) {
        const [remain, setRemain] = (0, react_1.useState)();
        const [isLoading, setIsLoading] = (0, react_1.useState)(() => {
            if (!base || base === "BTC" || base === "ETH") {
                return false;
            }
            return true;
        });
        const [errStr, setErrStr] = (0, react_1.useState)("");
        (0, react_1.useEffect)(() => {
            setErrStr("");
            if (!base || !quote || base === "BTC" || base === "ETH") {
                setRemain(undefined);
                return;
            }
            setIsLoading(true);
            const sub = exports.FSArbitragingProcessor.queryRemainInvestQuota(base, quote).subscribe({
                next: (res) => {
                    setRemain(res);
                    setIsLoading(false);
                },
                error: (error) => {
                    setRemain(undefined);
                    setIsLoading(false);
                    setErrStr(error);
                }
            });
            return () => sub.unsubscribe();
        }, [base, quote]);
        return [remain, isLoading, errStr];
    },
};
